import { render, staticRenderFns } from "./PendingPaymentInscriptionDialog.vue?vue&type=template&id=6c04d59e&"
import script from "./PendingPaymentInscriptionDialog.vue?vue&type=script&lang=js&"
export * from "./PendingPaymentInscriptionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports